import '@forest/shared/polyfills'

import './setup'

import { render } from 'solid-js/web'
import '~/styles/global.css'
import { App } from './app'
import { installDevNative } from './dev-native'

if (import.meta.env.DEV) installDevNative()

render(() => <App />, document.getElementById('root')!)
